// extracted by mini-css-extract-plugin
export var animationAbsolute = "_25-q";
export var animationRelative = "_25-p";
export var backdropBlur = "_25-0";
export var detailLabelCell = "_25-12";
export var detailTable = "_25-11";
export var detailValueCell = "_25-13";
export var docIconBox = "_25-1d";
export var docIconBoxMd = "_25-1f";
export var docIconBoxSm = "_25-1e";
export var docTypeRow = "_25-16";
export var docTypeRowInner = "_25-17";
export var dropdownMatchDatePicker = "_25-3";
export var evidenceCardContent = "_25-1c";
export var fileUploadSpin = "_25-j";
export var gorgiasOpenButton = "_25-15 _25-d";
export var gorgiasTicketCard = "_25-14";
export var heroModalFooterButton = "_25-18";
export var hiddenContainer = "_25-o";
export var iconPrimary = "_25-1g";
export var iconSecondary = "_25-1h";
export var iconTertiary = "_25-1i";
export var integrationCard = "_25-1";
export var integrationLogoBox = "_25-2";
export var mainColumnSticky = "_25-1b";
export var maxWidthContainer = "_25-19";
export var modalContentBody = "_25-a";
export var modalHeaderImage = "_25-5";
export var modalImageLabel = "_25-7";
export var modalImageOverlay = "_25-6";
export var modalImageSubtitle = "_25-9";
export var modalImageTitle = "_25-8";
export var modalImageWrapper = "_25-4";
export var modalStickyFooter = "_25-b";
export var removeButton = "_25-e";
export var sidebarColumn = "_25-1a";
export var spinner = "_25-i";
export var timelineLine = "_25-y";
export var timelineLineBlack = "_25-10 _25-y";
export var timelineLineGray = "_25-z _25-y";
export var timelineLineHeight = "_25-x";
export var tlDotActivate = "_25-u";
export var tlDotActivateAnim = "_25-t";
export var tlDotHide = "_25-s";
export var tlDotHideAnim = "_25-r";
export var tlLineActivate = "_25-w";
export var tlLineActivateAnim = "_25-v";
export var uploadHint = "_25-n";
export var uploadIconBox = "_25-k";
export var uploadLabel = "_25-m";
export var uploadText = "_25-l";
export var uploadZone = "_25-f";
export var uploadZoneCursorDefault = "_25-h";
export var uploadZoneCursorPointer = "_25-g";
export var uploadedFileRow = "_25-c";
export var viewButton = "_25-d";